import axios from "axios";
import { API_URL } from "constants";

export const fetch = () => {
  // One guard booth, one gate, one queue - so the list carries both directions.
  // getPendingTruckList merges the outbound and inbound feeds; every row says
  // which one it is in `type`.
  const url = `${API_URL}/?ajax&module=api&action=getPendingTruckList`;
  return axios
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        // Handle authentication error
        window.location.reload(); // This will trigger re-authentication
      }
      throw error;
    });
};

export const post = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=assignTerminalOrderNumber`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        // Handle authentication error
        window.location.reload(); // This will trigger re-authentication
      }
      throw error;
    });
};

// Individual action endpoints for security app
export const assignZone = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionAssignZone`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const invite = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionInvite`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const startWeighing = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionStartWeighing`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const readyToBeUploaded = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionReadyToBeUploaded`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const startUploading = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionStartUploading`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const finishUploading = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionFinishUploading`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const cancelUploading = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionCancelUploading`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const startWeighingAgain = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionStartWeighingAgain`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const requestDocuments = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionRequestDocuments`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const readyToLeave = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionReadyToLeave`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const requestRulesSignature = (id_transport, language, type) => {
  // id_transport is the direction-neutral name; id_upload_transport is sent too
  // so a deployed backend that has not been updated yet still understands it.
  const url = `${API_URL}/?ajax&module=api&action=signRulesDocument&id_transport=${id_transport}&id_upload_transport=${id_transport}&type=${type || "UPLOAD"}&language=${language}`;
  return axios
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const postTransportAdr = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=setTransportAdr`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

// The guard opens the barrier and lets the truck out (step 13 of the yard flow).
export const releaseTransport = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionReleaseTransport`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

// --- Night mode (dispatcher hands off the remaining yard steps to the guard) ---

export const getYardNightMode = () => {
  const url = `${API_URL}/?ajax&module=api&action=getYardNightMode`;
  return axios
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

// One generic step endpoint drives the whole night chain; step and expected
// must match so a truck someone else already moved surfaces as a conflict.
export const nightStep = (payload) => {
  const url = `${API_URL}/?ajax&module=api&action=actionNightStep`;
  return axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const uploadTransportDocument = (file, idTransport, type) => {
  const url = `${API_URL}/?ajax&module=api&action=uploadTransportDocument`;
  const formData = new FormData();
  formData.append("document", file);
  formData.append("id_transport", idTransport);
  formData.append("type", type);
  // The signed rules PDF is a separate flow - a guard's night-mode photo is
  // always the transport document itself.
  formData.append("doc_kind", "vaztarastis");

  return axios
    .post(url, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};

export const getTransportDocuments = (idTransport, type) => {
  const url = `${API_URL}/?ajax&module=api&action=getTransportDocuments&id_transport=${idTransport}&type=${type}`;
  return axios
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        window.location.reload();
      }
      throw error;
    });
};
